import { render, staticRenderFns } from "./page-mine-banner.vue?vue&type=template&id=4fc21fba&scoped=true&"
import script from "./page-mine-banner.vue?vue&type=script&lang=js&"
export * from "./page-mine-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc21fba",
  null
  
)

export default component.exports